// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fh","advertDetailContactItem__link":"c-n_fi"};